import '../assets/NcAppSettingsDialog-Csh7L4r1.css';
import { defineComponent, mergeModels, useModel, useSlots, provide, useTemplateRef, ref, computed, warn, createBlock, createCommentVNode, openBlock, unref, createSlots, withCtx, createElementVNode, renderSlot, createElementBlock, Fragment, renderList, withKeys, withModifiers, normalizeClass, toDisplayString } from "vue";
import debounce from "debounce";
import { N as NcDialog } from "./NcDialog-CdAQQLxt.mjs";
import { _ as _sfc_main$1 } from "./NcVNodes.vue_vue_type_script_lang-BqUHinRZ.mjs";
import { useIsMobile } from "../composables/useIsMobile/index.mjs";
import { r as register, a as t } from "./_l10n-DbErv0fW.mjs";
import { A as APP_SETTINGS_REGISTRATION_KEY } from "./useAppSettingsDialog-Dn48dw1k.mjs";
import { _ as _export_sfc } from "./_plugin-vue_export-helper-1tPrXgE0.mjs";
register();
const _hoisted_1 = {
  key: 0,
  class: "navigation-list"
};
const _hoisted_2 = ["aria-current", "href", "onClick", "onKeydown"];
const _hoisted_3 = {
  key: 0,
  class: "navigation-list__link-icon"
};
const _hoisted_4 = { class: "navigation-list__link-text" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "NcAppSettingsDialog",
  props: /* @__PURE__ */ mergeModels({
    showNavigation: { type: Boolean },
    container: { default: "body" },
    name: { default: "" },
    additionalTrapElements: { default: () => [] }
  }, {
    "open": { type: Boolean, ...{ required: true } },
    "openModifiers": {}
  }),
  emits: ["update:open"],
  setup(__props) {
    const open = useModel(__props, "open");
    const props = __props;
    const slots = useSlots();
    provide(APP_SETTINGS_REGISTRATION_KEY, {
      registerSection,
      unregisterSection
    });
    const settingsScrollerElement = useTemplateRef("settingsScroller");
    const isMobile = useIsMobile();
    const selectedSection = ref("");
    const linkClicked = ref(false);
    const registeredSections = ref([]);
    const hasNavigation = computed(() => !isMobile.value && props.showNavigation);
    const hasNavigationIcons = computed(() => registeredSections.value.some(({ icon }) => !!icon));
    const unfocusNavigationItem = debounce(() => {
      selectedSection.value = "";
      if (document.activeElement?.className.includes("navigation-list__link")) {
        document.activeElement.blur();
      }
    }, 300);
    function handleSettingsNavigationClick(item) {
      linkClicked.value = true;
      document.getElementById("settings-section_" + item).scrollIntoView({
        behavior: "smooth",
        inline: "nearest"
      });
      selectedSection.value = item;
      setTimeout(() => {
        linkClicked.value = false;
      }, 1e3);
    }
    function handleCloseModal(isOpen) {
      if (isOpen) {
        return;
      }
      open.value = false;
      settingsScrollerElement.value.scrollTop = 0;
    }
    function handleScroll() {
      if (open.value && !linkClicked.value) {
        unfocusNavigationItem();
      }
    }
    function registerSection(id, name, icon) {
      if (registeredSections.value.some(({ id: otherId }) => id === otherId)) {
        throw new Error(`Duplicate section id found: ${id}. Settings navigation sections must have unique section ids.`);
      }
      if (registeredSections.value.some(({ name: otherName }) => name === otherName)) {
        warn(`Duplicate section name found: ${name}. Settings navigation sections must have unique section names.`);
      }
      const newSections = [...registeredSections.value, { id, name, icon }];
      registeredSections.value = newSections.sort(({ id: idA }, { id: idB }) => {
        const indexOf = (id2) => slots.default?.().findIndex((vnode) => vnode?.props?.id === id2) ?? -1;
        return indexOf(idA) - indexOf(idB);
      });
      if (registeredSections.value.length === 1) {
        selectedSection.value = id;
      }
    }
    function unregisterSection(id) {
      registeredSections.value = registeredSections.value.filter(({ id: otherId }) => id !== otherId);
      if (selectedSection.value === id) {
        selectedSection.value = registeredSections.value[0]?.id ?? "";
      }
    }
    return (_ctx, _cache) => {
      return open.value ? (openBlock(), createBlock(NcDialog, {
        key: 0,
        class: "app-settings",
        "content-classes": "app-settings__content",
        "navigation-classes": "app-settings__navigation",
        "additional-trap-elements": _ctx.additionalTrapElements,
        container: _ctx.container,
        "close-on-click-outside": "",
        "navigation-aria-label": unref(t)("Settings navigation"),
        size: "large",
        name: _ctx.name,
        "onUpdate:open": handleCloseModal
      }, createSlots({
        default: withCtx(() => [
          createElementVNode("div", {
            ref: "settingsScroller",
            onScroll: handleScroll
          }, [
            renderSlot(_ctx.$slots, "default", {}, void 0, true)
          ], 544)
        ]),
        _: 2
      }, [
        hasNavigation.value ? {
          name: "navigation",
          fn: withCtx(({ isCollapsed }) => [
            !isCollapsed ? (openBlock(), createElementBlock("ul", _hoisted_1, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(registeredSections.value, (section) => {
                return openBlock(), createElementBlock("li", {
                  key: section.id
                }, [
                  createElementVNode("a", {
                    "aria-current": `${section.id === selectedSection.value}`,
                    class: normalizeClass(["navigation-list__link", {
                      "navigation-list__link--active": section.id === selectedSection.value,
                      "navigation-list__link--icon": hasNavigationIcons.value
                    }]),
                    href: `#settings-section_${section.id}`,
                    tabindex: "0",
                    onClick: withModifiers(($event) => handleSettingsNavigationClick(section.id), ["prevent"]),
                    onKeydown: withKeys(($event) => handleSettingsNavigationClick(section.id), ["enter"])
                  }, [
                    hasNavigationIcons.value ? (openBlock(), createElementBlock("div", _hoisted_3, [
                      section.icon ? (openBlock(), createBlock(_sfc_main$1, {
                        key: 0,
                        vnodes: section.icon
                      }, null, 8, ["vnodes"])) : createCommentVNode("", true)
                    ])) : createCommentVNode("", true),
                    createElementVNode("span", _hoisted_4, toDisplayString(section.name), 1)
                  ], 42, _hoisted_2)
                ]);
              }), 128))
            ])) : createCommentVNode("", true)
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["additional-trap-elements", "container", "navigation-aria-label", "name"])) : createCommentVNode("", true);
    };
  }
});
const NcAppSettingsDialog = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-5f3b5743"]]);
export {
  NcAppSettingsDialog as N
};
//# sourceMappingURL=NcAppSettingsDialog-CAVz10A2.mjs.map
